import chipStatusLabel from './chipStatusLabel'
import chipStatusColor from './chipStatusColor'
import chipStatusBgColor from './chipStatusBgColor'
import processChipStatusLabel from './processChipStatusLabel'
import processChipStatusColor from './processChipStatusColor'
import processChipStatusBgColor from './processChipStatusBgColor'
import kindTranslation from './kindTranslation'

export default {
  chipStatusLabel,
  chipStatusColor,
  chipStatusBgColor,
  processChipStatusLabel,
  processChipStatusColor,
  processChipStatusBgColor,
  kindTranslation,
}
